<template>
  <div class="light-box">
    <div class="container content">
      <div class="row">
        <div class="schedule-editor col">
          <h6 class="popup-label">
            Edit schedule
          </h6>

          <div
            v-for="date in getCampaignDays"
            :key="date.date">
            
            <h6 class="label">
              {{ getDate(date.date) }}
              <span>
                (
                  {{ getDayName(date.date) }}
                )
              </span>
            </h6>

            <event-day
              :max="getMaxPerDays"
              class="row"
              :date="date.date"
              :dayEvents="date.events"
              @eventUpdate="eventUpdate"
              @timeUpdate="timeUpdate"
              @removeEvent="removeEvent" />
              
          </div>
        </div>
      </div>


      <div class="spacer-submit" />


      <imput-button
        class="float-right"
        inputPlaceholder="Done"
        variant="standardInput"
        btnStyle="ok-style"
        @click="updateEvents" />

    </div>
  </div>
</template>

<script>
import ImputButton from '@/components/standard/input/InputButton'
import EventDay from '@/components/service/campaignManager/channelSelectionParts/EventDay'
import moment,{ updateLocale } from 'moment'
import uuidv1 from 'uuid/v1'

export default {
  data () {
    return {
      params: this.channelParams,
      daysEvents: this.setEventDays()
    }
  },
  props: {
    channelParams: {
      type: Object,
      required: false,
      default: () => {return {}}
    },
    channelRef: {
      required: false
    }
  },

  methods: {
    getDate (date) {
      return `${date}`
    },
    getDayName (date) {
      return moment(date).format('dddd')
    },

    removeEvent (e) {
      let {date, id} = e
      this.$delete(this.daysEvents[date], id)
    },
    timeUpdate (e) {
      let {date, eventId, time} = e

      this.$set(this.daysEvents[date][eventId], 'time', time)
    },
    eventUpdate (e) {
      let {add, date, event} = e
      if (add) {

        if (!this.daysEvents[date]) {
          this.$set(this.daysEvents, date, {})
        }

        let ins = {
          id: event.id,
          time: event.time
        }
        this.$set(this.daysEvents[date], event.id, ins)

      } else if (e.remove) {  }
    },

    updateEvents () {
      this.$emit('setSchedule', {
        events: this.daysEvents
      })
    },

    setEventDays () {
      let {startsAt, expiresAt, dayEvents} = this.channelParams

      let rtr = {}
      let diff = moment(expiresAt).diff(moment(startsAt), 'days')

      for (let i = 0; i < diff; i++) {
        let date = moment(startsAt).add(i, 'day').format('YYYY-MM-DD')

        let insert = {}
        if (dayEvents[date]) {
          insert = dayEvents[date]
        }
        rtr[date] = insert
      }
      return rtr
    },
  },

  computed: {
    getMaxPerDays () {
      return this.params.maxPerDay
    },
    getCampaignDays () {
      return Object.entries(this.daysEvents).map(de => {
        return {
          date: de[0],
          events: de[1]
        }
      })
    }
  },

  components: {
    'imput-button': ImputButton,
    'event-day': EventDay
  }
}
</script>

<style scoped>
.campaign-se {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(53, 54, 53, 0.88);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
}

.schedule-editor {
  padding: 20px 30px;
  background-color: #FFFFFF;
  border-radius: 10px;
}

.popup-label {
  color: #353635;
  font-size: 20px;
  font-weight: bold;
}
.label span {
  font-weight: lighter;
  font-size: 12px;
}
.label {
  font-weight: bold;
}

.spacer-submit {
  margin-top: 20px;
}

.content {
  max-height: 100%;
  overflow-y: scroll;
}

.content::-webkit-scrollbar {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/service/campaignManager/CampaignScheduleEditor.vue?8c867e60